var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessSaleDropLoss({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8745 7.30263C20.7431 6.94626 20.5104 6.63992 20.2073 6.42438C19.9042 6.20884 19.5451 6.09433 19.1777 6.09611H15.827C15.7266 6.09598 15.6304 6.05446 15.5594 5.98068C15.4884 5.90689 15.4485 5.80686 15.4485 5.70255V2.12504C15.4479 1.56166 15.2322 1.02153 14.8487 0.623148C14.4653 0.224767 13.9453 0.000664684 13.403 0H7.78056C7.23832 0.000686426 6.71849 0.224819 6.33515 0.623216C5.9518 1.02161 5.73625 1.56173 5.7358 2.12504V5.70255C5.73576 5.80685 5.69588 5.90686 5.62493 5.98065C5.55398 6.05443 5.45775 6.09596 5.35735 6.09611H1.81924C1.45247 6.09617 1.09428 6.21138 0.791646 6.42663C0.489008 6.64188 0.25605 6.94712 0.123323 7.30232C-0.00940487 7.65752 -0.035706 8.0461 0.0478676 8.4171C0.131441 8.7881 0.320988 9.1242 0.591652 9.38133L9.03481 17.405C9.43346 17.7876 9.95621 18 10.4989 18C11.0416 18 11.5643 17.7876 11.963 17.405L20.4061 9.38173C20.6782 9.12562 20.8688 8.78948 20.9524 8.41807C21.0361 8.04666 21.0089 7.65758 20.8745 7.30263Z",
    fill: "#747BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessSaleDropLoss);
export default __webpack_public_path__ + "static/media/Business_sale_drop_loss.f05adcd40934b762e886e09684443ae7.svg";
export { ForwardRef as ReactComponent };